/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-tracker
 * Portfolio-tracker
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InvestownMonthlyStatusDto
 */
export interface InvestownMonthlyStatusDto {
    /**
     * 
     * @type {string}
     * @memberof InvestownMonthlyStatusDto
     */
    month: string;
    /**
     * 
     * @type {number}
     * @memberof InvestownMonthlyStatusDto
     */
    invested: number;
    /**
     * 
     * @type {number}
     * @memberof InvestownMonthlyStatusDto
     */
    interestYield: number;
    /**
     * 
     * @type {number}
     * @memberof InvestownMonthlyStatusDto
     */
    rewards: number;
    /**
     * 
     * @type {number}
     * @memberof InvestownMonthlyStatusDto
     */
    fees: number;
    /**
     * 
     * @type {number}
     * @memberof InvestownMonthlyStatusDto
     */
    profit: number;
}

export function InvestownMonthlyStatusDtoFromJSON(json: any): InvestownMonthlyStatusDto {
    return InvestownMonthlyStatusDtoFromJSONTyped(json, false);
}

export function InvestownMonthlyStatusDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): InvestownMonthlyStatusDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'month': json['month'],
        'invested': json['invested'],
        'interestYield': json['interestYield'],
        'rewards': json['rewards'],
        'fees': json['fees'],
        'profit': json['profit'],
    };
}

export function InvestownMonthlyStatusDtoToJSON(value?: InvestownMonthlyStatusDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'month': value.month,
        'invested': value.invested,
        'interestYield': value.interestYield,
        'rewards': value.rewards,
        'fees': value.fees,
        'profit': value.profit,
    };
}

